/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Mon Apr 12 2021 10:10:46 GMT+0200 (czas środkowoeuropejski letni)
 */
import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.PRINTING;
export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface File {
  absolute: boolean;
  absoluteFile: File;
  absolutePath: string;
  canonicalFile: File;
  canonicalPath: string;
  directory: boolean;
  file: boolean;
  freeSpace: number;
  hidden: boolean;
  name: string;
  parent: string;
  parentFile: File;
  path: string;
  totalSpace: number;
  usableSpace: number;
}

export interface InputStream {}

export interface JobExecutionResponse {
  code: string;
  description: string;
  errorfile: string;
  jobid: number;
  logfile: string;
  message: string;
  outputfile: string;
  servicename: string;
}

export interface ParPrint {
  ciinvoicetype: string;
  citype: string;
  contenttype: string;
  doccode: string;
  docmodule: string;
  docstatus: string;
  doctemplate: string;
  emailsubject: string;
  id: number;
  mgid: number;
  networkcode: string;
  offerid: number;
  paymode: string;
  paytype: string;
  prcode: string;
  printtype: string;
}

export interface ParPrintAttachment {
  attdoccode: string;
  attid: number;
  doccode: string;
}

export interface DocToPrintAndEmailResponse {
  doccode: string;
  conseqid: number;
  notifid: number;
  entityid: number;
  entity: string;
  flagEmail: Boolean;
  emailTo: string;
  emailCc: string;
}

export interface ParPrintAttachmentResponse {
  attdoccode: string;
  attdoccodelabel: string;
  attid: number;
  doccode: string;
}

export interface ParPrintContext {
  context: string;
  ctxid: number;
  doccode: string;
}

export interface ParPrintContextResponse {
  context: string;
  contextlabel: string;
  ctxid: number;
  doccode: string;
}

export interface ParPrintRequest {
  ciinvoicetype: string;
  citype: string;
  contenttype: string;
  doccode: string;
  doclabel: string;
  docmodule: string;
  docstatus: string;
  doctemplate: string;
  emailsubject: string;
  id: number;
  mgid: number;
  networkcode: string;
  offerid: number;
  paymode: string;
  paytype: string;
  prcode: string;
  printtype: string;
}

export interface ParPrintResponse {
  ciinvoicetype: string;
  citype: string;
  contenttype: string;
  contenttypelabel: string;
  doccode: string;
  doclabel: string;
  docmodule: string;
  docmodulelabel: string;
  docstatus: string;
  docstatuslabel: string;
  doctemplate: string;
  emailsubject: string;
  id: number;
  mgid: number;
  nbTemplate: number;
  networkcode: string;
  offerid: number;
  parPrintAttachmentList: Array<ParPrintAttachmentResponse>;
  parPrintContextList: Array<ParPrintContextResponse>;
  paymode: string;
  paytype: string;
  prcode: string;
  printtype: string;
  printtypelabel: string;
}

export interface Print {
  assetid: number;
  assetreference: string;
  ciid: number;
  cireference: string;
  conseqid: number;
  contenttype: string;
  ctreference: string;
  ctrid: number;
  doccode: string;
  docfolder: string;
  doclabel: string;
  docmodule: string;
  doctemplate: string;
  emailsubject: string;
  emailto: string;
  filename: string;
  jobid: number;
  mgid: number;
  payid: number;
  payreference: string;
  poid: number;
  poreference: string;
  printdate: string;
  printid: number;
  printidparent: number;
  printstatus: string;
  printstatusdate: string;
  printtype: string;
  siid: number;
  sireference: string;
  tpid: number;
  tpname: string;
  tpreference: string;
  useridprint: number;
  useridstatus: number;
  colreference: string;
  colid: number;
}

export interface Resource {
  description: string;
  file: File;
  filename: string;
  inputStream: InputStream;
  open: boolean;
  readable: boolean;
  uri: URI;
  url: URLs;
}

export interface URI {
  absolute: boolean;
  authority: string;
  fragment: string;
  host: string;
  opaque: boolean;
  path: string;
  port: number;
  query: string;
  rawAuthority: string;
  rawFragment: string;
  rawPath: string;
  rawQuery: string;
  rawSchemeSpecificPart: string;
  rawUserInfo: string;
  scheme: string;
  schemeSpecificPart: string;
  userInfo: string;
}

export interface URLs {
  authority: string;
  content: {};
  defaultPort: number;
  file: string;
  host: string;
  path: string;
  port: number;
  protocol: string;
  query: string;
  ref: string;
  userInfo: string;
}

export interface GetTPCommunicationParams {
  tpid: number;
}

/**
 * @tags Printing Controller
 * @summary getTPCommunication
 */
export function getTPCommunication(params: GetTPCommunicationParams) {
  return request.get<AbstractResponse<object, Print>>(
    `${URL}/api/communication/${params.tpid}`
  );
}

export interface DownloadPDFResourceParams {
  doccode: string;
  entity?: string;
  entityid: number;
  token: string;
}

/**
 * @tags Printing Controller
 * @summary downloadPDFResource
 */
export function downloadPDFResource(params: DownloadPDFResourceParams) {
  return request.get<any>(
    `${URL}/api/download` +
      prepareQueryParams({
        doccode: params.doccode,
        entity: params.entity,
        entityid: params.entityid,
        token: params.token,
      } as any)
  );
}

export interface GetParPrintListByCriteriaParams {
  contenttype: string;
  doccode: string;
  docmodule: string;
  docstatus: string;
  doctemplate: string;
  prcode: string;
  printtype: string;
}

/**
 * @tags Par Printing Controller
 * @summary getParPrintListByCriteria
 */
export function getParPrintListByCriteria(
  params: GetParPrintListByCriteriaParams
) {
  return request.get<AbstractResponse<object, ParPrintResponse>>(
    `${URL}/api/parprint` +
      prepareQueryParams({
        contenttype: params.contenttype,
        doccode: params.doccode,
        docmodule: params.docmodule,
        docstatus: params.docstatus,
        doctemplate: params.doctemplate,
        prcode: params.prcode,
        printtype: params.printtype,
      } as any)
  );
}

export interface CreateParPrintParams {
  request: ParPrintRequest;
}

/**
 * @tags Par Printing Controller
 * @summary createParPrint
 */
export function createParPrint(params: CreateParPrintParams) {
  return request.post<AbstractResponse<ParPrintResponse, object>>(
    `${URL}/api/parprint`,
    params.request
  );
}

export interface GetParPrintDetailParams {
  doccode: string;
}

/**
 * @tags Par Printing Controller
 * @summary getParPrintDetail
 */
export function getParPrintDetail(params: GetParPrintDetailParams) {
  return request.get<AbstractResponse<ParPrintResponse, object>>(
    `${URL}/api/parprint/${params.doccode}`
  );
}

export interface UpdateParPrintParams {
  doccode: string;
  request: ParPrintResponse;
}

/**
 * @tags Par Printing Controller
 * @summary updateParPrint
 */
export function updateParPrint(params: UpdateParPrintParams) {
  return request.put<AbstractResponse<ParPrintResponse, object>>(
    `${URL}/api/parprint/${params.doccode}`,
    params.request
  );
}

export interface UpdateParPrintStatusParams {
  doccode: string;
  docstatus: string;
}

/**
 * @tags Par Printing Controller
 * @summary updateParPrintStatus
 */
export function updateParPrintStatus(params: UpdateParPrintStatusParams) {
  return request.put<AbstractResponse<ParPrintResponse, object>>(
    `${URL}/api/parprint/${params.doccode}/${params.docstatus}`
  );
}

export interface CreateParPrintAttachementParams {
  request: ParPrintAttachment;
}

/**
 * @tags Par Printing Attachment Controller
 * @summary CreateParPrintAttachement
 */
export function CreateParPrintAttachement(
  params: CreateParPrintAttachementParams
) {
  return request.post<AbstractResponse<ParPrintAttachmentResponse, object>>(
    `${URL}/api/parprintattachment`,
    params.request
  );
}

export interface RemoveParPrintAttachementParams {
  attid: number;
}

/**
 * @tags Par Printing Attachment Controller
 * @summary removeParPrintAttachement
 */
export function removeParPrintAttachement(
  params: RemoveParPrintAttachementParams
) {
  return request.delete<AbstractResponse<ParPrintAttachmentResponse, object>>(
    `${URL}/api/parprintattachment/${params.attid}`
  );
}

export interface addParPrintContextParams {
  request: ParPrintContext;
}

export function addParPrintContext(params: addParPrintContextParams) {
  return request.post<AbstractResponse<ParPrintContextResponse, object>>(
    `${URL}/api/parprintcontext`,
    params.request
  );
}

export interface removeParPrintContextParams {
  ctxid: number;
}

export function removeParPrintContext(params: removeParPrintContextParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parprintcontext/${params.ctxid}`
  );
}

export interface GetPrintListByCriteriaParams {
  cireference: string;
  ctreference: string;
  doccode: string;
  docmodule: string;
  mgid: number;
  payreference: string;
  colreference: string;
  poreference: string;
  printstatus: string;
  sireference: string;
  tpname: string;
  tpreference: string;
  printtype: string;
}

/**
 * @tags Printing Controller
 * @summary getPrintListByCriteria
 */
export function getPrintListByCriteria(params: GetPrintListByCriteriaParams) {
  return request.get<AbstractResponse<object, Print>>(
    `${URL}/api/print` +
      prepareQueryParams({
        cireference: params.cireference,
        ctreference: params.ctreference,
        doccode: params.doccode,
        docmodule: params.docmodule,
        mgid: params.mgid,
        payreference: params.payreference,
        colreference: params.colreference,
        poreference: params.poreference,
        printstatus: params.printstatus,
        sireference: params.sireference,
        tpname: params.tpname,
        tpreference: params.tpreference,
        printtype: params.printtype,
      } as any)
  );
}

export interface PrintDocumentParams {
  Authorization: string;
  conseqid: number;
  doccode: string;
  entity: string;
  entityid: number;
  execMode?: string;
  subentity?: string;
  subentityid?: number;
}

/**
 * @tags Printing Controller
 * @summary printDocument
 */
export function printDocument(params: PrintDocumentParams) {
  return request.get<any>(
    `${URL}/api/print/document` +
      prepareQueryParams({
        conseqid: params.conseqid,
        doccode: params.doccode,
        entity: params.entity,
        entityid: params.entityid,
        execMode: params.execMode,
        subentity: params.subentity,
        subentityid: params.subentityid,
      } as any)
  );
}
export interface DownloadPrintedFileParams {
  printid: number;
}

/**
 * @tags Printing Controller
 * @summary downloadPrintedFile
 */
export function downloadPrintedFile(params: DownloadPrintedFileParams) {
  return request.get<Resource>(
    `${URL}/api/print/download` +
      prepareQueryParams({ printid: params.printid } as any)
  );
}

export interface GenClientInvoicePDFandEmailParams {
  Authorization: string;
  cirefend: string;
  cirefstart: string;
  emailmode?: string;
  groupingLines: string;
  jobid?: number;
  mgid: number;
  printingmode?: string;
  flagEditAllInOne?: boolean;
}

/**
 * @tags Printing Controller
 * @summary genClientInvoicePDFandEmail
 */
export function genClientInvoicePDFandEmail(
  params: GenClientInvoicePDFandEmailParams
) {
  return request.get<JobExecutionResponse>(
    `${URL}/api/printing/run/clientInvoice` +
      prepareQueryParams({
        cirefend: params.cirefend,
        cirefstart: params.cirefstart,
        emailmode: params.emailmode,
        groupingLines: params.groupingLines,
        jobid: params.jobid,
        mgid: params.mgid,
        printingmode: params.printingmode,
        flagEditAllInOne: params.flagEditAllInOne,
      } as any)
  );
}

export interface ManualRunPrintDocumentOrSendEmailParams {
  doccode: string;
  conseqid: number;
  notifid: number;
  entityid: number;
  entity: string;
  subentityid: number;
  subentity: string;
  flagEmail: string;
  emailTo: string;
  emailCc: string;
}
export function manualRunPrintDocumentOrSendEmail(
  params: ManualRunPrintDocumentOrSendEmailParams
) {
  return request.get<JobExecutionResponse>(
    `${URL}/api/printing/run/manualRunPrintDocumentOrSendEmail` +
      prepareQueryParams({
        doccode: params.doccode,
        conseqid: params.conseqid,
        notifid: params.notifid,
        entityid: params.entityid,
        entity: params.entity,
        subentityid: params.subentityid,
        subentity: params.subentity,
        flagEmail: params.flagEmail,
        emailTo: params.emailTo,
        emailCc: params.emailCc,
        execMode: 'DB',
      })
  );
}

export interface ParPrintTemplateResponse {
  doccode: string;
  flagdefault: boolean;
  htmltemplate: string;
  lancode: string;
  templatename: string;
}

export interface GetTemplatesListbyDoccodeParams {
  doccode: string;
}

/**
 * @tags Par Printing Controller
 * @summary getTemplatesListbyDoccode
 */
export function getTemplatesListbyDoccode(
  params: GetTemplatesListbyDoccodeParams
) {
  return request.get<AbstractResponse<object, ParPrintTemplateResponse>>(
    `${URL}/api/templatelist/${params.doccode}`
  );
}

export interface ParPrintTemplateRequest {
  id?: number;
  doccode: string;
  flagdefault: boolean;
  htmltemplate: string;
  lancode: string;
  templatename: string;
}

export interface CreateParPrintTemplateParams {
  request: ParPrintTemplateRequest;
}

/**
 * @tags Par Printing Controller
 * @summary createParPrintTemplate
 */
export function createParPrintTemplate(params: CreateParPrintTemplateParams) {
  return request.post<AbstractResponse<ParPrintTemplateResponse, object>>(
    `${URL}/api/parprinttemplate`,
    params.request
  );
}

export interface RemoveParPrintTemplateParams {
  doccode: string;
  lancode: string;
}

/**
 * @tags Par Printing Controller
 * @summary removeParPrintTemplate
 */
export function removeParPrintTemplate(params: RemoveParPrintTemplateParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/parprinttemplate/${params.doccode}/${params.lancode}`
  );
}

export interface GetTemplatesbyDoccodeAndLancodeParams {
  doccode: string;
  lancode: string;
}

/**
 * @tags Par Printing Controller
 * @summary getTemplatesbyDoccodeAndLancode
 */
export function getTemplatesbyDoccodeAndLancode(
  params: GetTemplatesbyDoccodeAndLancodeParams
) {
  return request.get<AbstractResponse<ParPrintTemplateResponse, object>>(
    `${URL}/api/template/${params.doccode}/${params.lancode}`
  );
}

export interface UpdateParPrintTemplateParams {
  doccode: string;
  lancode: string;
  request: ParPrintTemplateRequest;
}

/**
 * @tags Par Printing Controller
 * @summary updateParPrintTemplate
 */
export function updateParPrintTemplate(params: UpdateParPrintTemplateParams) {
  return request.put<AbstractResponse<ParPrintTemplateResponse, object>>(
    `${URL}/api/parprinttemplate/${params.doccode}/${params.lancode}`,
    params.request
  );
}

export interface DefaultTemplateParams {
  doccode: string;
  lancode: string;
}

/**
 * @tags Par Printing Controller
 * @summary defaultTemplate
 */
export function defaultTemplate(params: DefaultTemplateParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/defaulttemplate/${params.doccode}/${params.lancode}`
  );
}
export interface PrintDocumentHtmlParams {
  Authorization: string;
  conseqid: number;
  doccode: string;
  entity: string;
  entityid: number;
  execMode?: string;
  subentity?: string;
  subentityid?: number;
  lancode: string;
}

/**
 * @tags Printing Controller
 * @summary printDocumentHtml
 */
export function printDocumentHtml(params: PrintDocumentHtmlParams) {
  return request.get<AbstractResponse<object, object>>(
    `${URL}/api/print/documenthtml` +
      prepareQueryParams({
        conseqid: params.conseqid,
        doccode: params.doccode,
        entity: params.entity,
        entityid: params.entityid,
        execMode: params.execMode,
        subentity: params.subentity,
        subentityid: params.subentityid,
        lancode: params.lancode,
      } as any)
  );
}

export interface ContextResponse {
  context: string;
  contextResponseList: Array<ContextResponse>;
  responseContextJson: string;
}

export interface GetResponseContextParams {
  entity: string;
  doccode: string;
}

/**
 * @tags Par Printing Controller
 * @summary getResponseContext
 */
export function getResponseContext(params: GetResponseContextParams) {
  return request.get<AbstractResponse<ContextResponse, object>>(
    `${URL}/api/responsecontext/${params.entity}/${params.doccode}`
  );
}

export interface GenerateMassiveDocToPrintAndEmailParams {
  docToPrintAndEmailResponses: Array<DocToPrintAndEmailResponse>;
  execMode: string;
  kafkaEnabled: string;
  printAllInOne: boolean;
}

/**
 * @tags Printing Controller
 * @summary generateMassiveDocToPrintAndEmail
 */
export function generateMassiveDocToPrintAndEmail (params: GenerateMassiveDocToPrintAndEmailParams) {
  return request.post<AbstractResponse<object,object>>(`${URL}/api/print/generateMassiveDocs` + prepareQueryParams({execMode: params.execMode, kafkaEnabled: params.kafkaEnabled, printAllInOne: params.printAllInOne} as any), params.docToPrintAndEmailResponses)
};